module.exports = __webpack_public_path__ + "static/media/pageBg.f9f9dcd5.png";